import React from 'react';

// import route Components here
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

import MenuIcon from "../../img/menu.svg";
import LOGO from "../../img/foco90.svg";

//pages
import MeuTreino from '../treino/Page';
import MeuPerfil from '../perfil/Page';
import PlanoAlimentar from '../meu-plano-alimentar/Page';
import Exercicios from '../exercicios/Page';
import Medidas from '../medidas/Page';
import TermosUso from '../termos-uso/Page';
import Perguntas from '../perguntas/Page';
import Mensagens from '../mensagens/Mensagens';
import Sobre from '../sobre/Page';
import Ebook from '../ebook/Page';
import Tecnicas from '../tecnicas/Page';
import Welcome from '../welcome/Page';

import Header from '../header/Header';
import Menu from '../menu/Menu';
import Toolbar from '../toolbar/Toolbar';

class AreaRestrita extends React.Component{
  constructor(props) {
      super(props);

      this.callMenu = this.callMenu.bind(this);
  }

  componentDidMount(){
    if(!window.localStorage.getItem('email')){
      this.props.history.push('/');
    }
  }

  callMenu(e) {
    e.preventDefault();

    const menu = document.getElementById('menu');
    menu.classList.add("open");
  }

  render(){
    const match = this.props.match;

    return(
      <div className="area-restrita">
        <img src={LOGO} width='130' className='logo-mobile' />
        <a href='#' className='button-menu' onClick={this.callMenu}>
          <img src={MenuIcon} />
          <span className='button-menu__txt'>Menu</span>
        </a>
        <div className='content-wrapper'>
          <Header />
          <Menu history={this.props.history} />
          <Route key={Math.random()} exact path={`${match.path}/meu-treino/`} component={MeuTreino}/>
          <Route key={Math.random()} exact path={`${match.path}/meu-perfil/`} component={MeuPerfil}/>
          <Route key={Math.random()} exact path={`${match.path}/meu-plano-alimentar/`} component={PlanoAlimentar}/>
          <Route key={Math.random()} exact path={`${match.path}/exercicios/`} component={Exercicios}/>
          <Route key={Math.random()} exact path={`${match.path}/minhas-medidas/`} component={Medidas}/>
          <Route key={Math.random()} exact path={`${match.path}/termos-uso/`} component={TermosUso}/>
          <Route key={Math.random()} exact path={`${match.path}/perguntas-frequentes/`} component={Perguntas}/>
          <Route key={Math.random()} exact path={`${match.path}/mensagens/`} component={Mensagens}/>
          <Route key={Math.random()} exact path={`${match.path}/sobre/`} component={Sobre}/>
          <Route key={Math.random()} exact path={`${match.path}/e-book/`} component={Ebook}/>
          <Route key={Math.random()} exact path={`${match.path}/tecnicas/`} component={Tecnicas}/>
          <Route key={Math.random()} exact path={`${match.path}/bem-vindo/`} component={Welcome}/>
          <div className='clear'></div>
        </div>
        <Toolbar />
      </div>
    );
  }
}

export default AreaRestrita;



// WEBPACK FOOTER //
// ./src/classes/area-restrita/AreaRestrita.js